<template>
	<div class="trigger-waiting-for-event display-flex flex-column width-100 height-100 flex-centerize">
		<MessageBox :title="title" maxWidth="350px">
			<slot name="content" />
		</MessageBox>
		<div class="outter-content mt-7 text-align-center">
			<slot name="bottom" />
		</div>
	</div>
</template>

<script>
import MessageBox from './MessageBox';

export default {
	name: 'FloatingMessage',
	components: {
		MessageBox,
	},
	props: {
		title: { type: String },
		triggerEvent: { type: String },
	},
};
</script>

<style scoped lang="scss">
$overlay-z-index: 50;

.trigger-waiting-for-event {
	position: absolute;
	bottom: 0;
	width: 100%;
	top: auto;
	left: 50%;
	transform: translateX(-50%);
	// background: rgba(0, 0, 0, 0.7);
	z-index: $overlay-z-index + 5;
	overflow: hidden;
	transition: 0.4s;
	height: 100%;
}
.outter-content {
	&,
	a {
		color: white;
	}
}
</style>
